import { Box, Button, Flex, TextArea } from "@radix-ui/themes";
import { PaperPlaneIcon, PlusIcon } from "@radix-ui/react-icons";
import styles from "./ImproveChat.module.scss";
import { MultiDotsIcon } from "@/v2/assets/icons/MultiDotsIcon";

interface ImproveChatInputProps {
  input: string;
  isLoading: boolean;
  onSubmit: (event?: React.FormEvent) => void;
  onChange: (value: string) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

export function ImproveChatInput({
  input,
  isLoading,
  onSubmit,
  onChange,
  onKeyDown,
  disabled = false,
}: ImproveChatInputProps) {
  return (
    <Flex align="start" gap="3" className={styles.inputContainer}>
      <Flex direction="column" align="center" className={styles.inputIcon}>
        <Flex align="center" justify="center" className={styles.timelineIcon}>
          <MultiDotsIcon />
        </Flex>
      </Flex>
      <Box asChild flexGrow="1">
        <form onSubmit={onSubmit}>
          <Flex direction="column" className={styles.inputWrapper}>
            <TextArea
              value={input}
              onChange={(event) => onChange(event.target.value)}
              onKeyDown={onKeyDown}
              placeholder="What would you like to do?"
              disabled={isLoading || disabled}
              rows={3}
              resize="none"
              className={styles.textarea}
              dir="auto"
            />
            <Flex
              gap="2"
              justify="end"
              align="center"
              className={styles.buttonRow}
            >
              <Button
                type="submit"
                size="1"
                variant="solid"
                color="gray"
                highContrast
                disabled={!input?.trim() || isLoading || disabled}
                className={styles.sendButton}
              >
                <PaperPlaneIcon width={12} height={12} />
              </Button>
            </Flex>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
}
